<template>
  <layout-main-inner title="商品备案">
    <div slot="action">
      <safety-stocks-info-btn />
    </div>
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <!-- <template
        v-if="userPermission.ENT"
        slot="title">
        <create-prod-btn />
      </template> -->
      <template slot="form">
        <!-- <assign-ent-select
          v-if="userPermission.SUPERVISE || userPermission.OPERATE"
          v-model="config.vendorId"
          immediate
          style="margin-right: 10px"
          :option="{}"
          :callback="() => {handleCurrentChange(1)}" /> -->
        <el-radio-group
          v-model="config.productTypes"
          style="margin-right: 10px"
          @change="handleCurrentChange(1)">
          <el-radio-button :label="[1,9]">全部</el-radio-button>
          <el-radio-button :label="[1]">成品</el-radio-button>
          <el-radio-button :label="[9]">外购</el-radio-button>
        </el-radio-group>
        <el-input
          v-model="config.productName"
          placeholder="请输入商品名称"
          clearable
          style="width: 200px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        stripe
        :data="list">
        <el-table-column
          label="商品名称"
          :resizable="false">
          <template slot-scope="{row}">
            <link-route :link-to="`/product-detail?vendorId=${row.vendorId}&productId=${row.productId}`">
              {{ row.productName }}<span v-if="row.productNameRemark">({{ row.productNameRemark }})</span>
            </link-route>
          </template>
        </el-table-column>
        <el-table-column
          label="商品编号"
          width="100"
          :resizable="false"
          prop="productNumber">
        </el-table-column>
        <el-table-column
          label="商品类别"
          width="80"
          :resizable="false"
          prop="productTypeName">
        </el-table-column>
        <el-table-column
          label="商品品种"
          width="120"
          :resizable="false"
          prop="categoryName">
        </el-table-column>
        <!-- <el-table-column
          label="商品系列"
          width="100"
          :resizable="false"
          prop="productLineName">
        </el-table-column> -->
        <!-- <el-table-column
          label="安全库存"
          :resizable="false"
          width="100">
          <template slot-scope="{row}">
            <span style="margin-right:5px;">{{ row.safetyStock }}</span>
            <safe-inventory-popover
              :id="row.productId"
              :callback="fetchList"
              :value="row.safetyStock" />
          </template>
        </el-table-column> -->
        <el-table-column
          label="BOM表配置"
          :resizable="false"
          width="100">
          <template slot-scope="{row}">
            <el-tag
              v-if="row.hasBom"
              type="success">已配置</el-tag>
            <el-tag
              v-if="!row.hasBom"
              type="danger">未配置</el-tag>
            <!-- {{ row.hasBom ? '已配置' : '未配置' }} -->
          </template>
        </el-table-column>
        <el-table-column
          label="备案时间"
          :resizable="false"
          width="140">
          <template slot-scope="{row}">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="是否无码产品"
          :resizable="false"
          prop="codingType"
          width="100">
          <template slot-scope="{row}">
            <el-switch
              v-if="operation['coding-type']"
              :value="row.codingType"
              :active-value="9"
              :inactive-value="1"
              @change="(e)=> { onChange(row, e, 'codingType')}">
            </el-switch>
            <span v-else> {{ row.codingType === 9 ? '无码' : '有码' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          :resizable="false"
          width="95">
          <template slot-scope="{row}">
            <!-- <template v-if="row.productType === 1">
              <el-button
                v-if="operation['bom']"
                type="warning"
                @click.native="editBom(row)">
                BOM表
              </el-button>
              <el-button
                v-if="row.hasBom && !operation['bom']"
                type="warning"
                @click.native="editBom(row)">
                BOM表
              </el-button>
            </template>
            <el-button
              type="info"
              @click.native="setsafetystock(row)">
              安全库存
            </el-button> -->
            <!-- <el-button
              type="warning"
              @click="deleteProduct(row)">DOM表配置</el-button> -->
            <el-dropdown>
              <el-button type="info">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <template v-if="row.productType === 1">
                  <el-dropdown-item
                    v-if="operation['bom']"
                    @click.native="editBom(row)">BOM表配置</el-dropdown-item>
                  <el-dropdown-item
                    v-if="row.hasBom && !operation['bom']"
                    @click.native="editBom(row)">BOM表查看</el-dropdown-item>
                </template>
                <el-dropdown-item
                  @click.native="setsafetystock(row)">安全库存配置</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <bom-modal
      ref="bom"
      :edit="!!operation['bom']" />
    <safety-stocks-modal
      ref="stocks"
      :edit="true" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import BomModal from './busi/bom-modal.vue'
import SafetyStocksInfoBtn from './busi/safety-stocks-info-btn.vue'
import SafetyStocksModal from './busi/safety-stocks-modal.vue'

// import AssignEntSelect from '@/components/business/assign-ent-select.vue'
// import CreateProdBtn from './busi/create-prod-btn.vue'
// import SafeInventoryPopover from './safe-inventory-popover.vue'

export default {
  name: 'ProductList',
  components: { BomModal, SafetyStocksModal, SafetyStocksInfoBtn },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        productTypes: [1, 9],
        productName: '',
        status: 2
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission,
      query: state => state.common.query
    }),
    operation() {
      const module = this.$store.state.account.module.find(s => s.activePath === 'production') || {}
      const operations = ((module.children || []).find(m => m.funcId === 100) || {}).operations || []
      const rules = {}
      operations.forEach(s => {
        rules[s.operation] = s
      })
      return rules
    }
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    onChange(row, e, prop) {
      console.log(e)
      this.$confirm(`此操作将切换该商品为${e === 9 ? '无码商品' : '有码商品'}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('product/updateproduct', {
          payload: {
            productId: row.productId,
            [prop]: e
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('product/getproducts', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              productTypeName: i.productType === 1 ? '成品' : '外购'
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    // getsafetystocks() {
    //   this.$refs.info.fetch()
    // },
    getboms(row, cb) {
      this.loading = true
      this.$store.dispatch('product/getboms', {
        payload: {
          productId: row.productId,
          vendorId: row.vendorId
        },
        success: (res) => {
          this.loading = false
          // this.fetchList()
          cb && cb(res.data.records[0])
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    setsafetystock(row) {
      this.loading = true
      this.$store.dispatch('product/getsafetystocks', {
        payload: {
          productId: row.productId,
          pageNum: 1,
          pageSize: 10000
        },
        success: (res) => {
          this.loading = false
          this.$refs.stocks.fetch({
            productId: row.productId,
            productName: row.productName,
            list: res.data.records,
            productType: row.productType,
            measureUnit: row.measureUnit
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    editBom(row) {
      this.getboms(row, (option = {}) => {
        console.log(option)
        this.$refs.bom.fetch(row, option)
      })
    },
    viewBom(row) {
      this.getboms(row, (option = {}) => {
        console.log(option)
      })
    },
    deleteProduct(row) {
      this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('product/deleteproduct', {
            payload: {
              productId: row.productId,
              vendorId: row.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  }
}
</script>
